<template>
  <div>
    <table class="slds-table slds-table_cell-buffer slds-table_bordered">
      <thead>
        <tr class="slds-line-height_reset">
          <th v-if="hasActions">{{nbsp}}</th>
          <th class scope="col" v-for="(header, index) in headers.names" :key="index">
            <div class="slds-truncate" :title="header">{{header}}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="mode === 'view'">
          <tr class="slds-hint-parent" v-for="(row, index) in rowsToShow" :key="index">
            <td v-if="hasDeleteAction">
              <button
                class="slds-button slds-button_icon slds-button_icon-error"
                :title="$t('action.delete')"
                @click="$emit('deleteRow', { rowIndex: index })">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </td>
            <template v-for="(column, colIndex) in Object.values(row)">
              <td :data-label="headers.names[colIndex]" :key="colIndex">
                <div class="slds-truncate wrap" :title="headers.names[colIndex]">{{column}}</div>
              </td>
            </template>
          </tr>
        </template>
        <template v-else>
          <tr class="slds-hint-parent" v-for="(row, index) in rowsToShow" :key="index">
            <td v-if="hasDeleteAction">
              <button
                class="slds-button slds-button_icon slds-button_icon-error"
                :title="$t('action.delete')"
                @click="$emit('deleteRow', { rowIndex: index })">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </td>
            <template v-for="(column, colIndex) in headers.names">
              <td :data-label="headers.names[colIndex]" :key="colIndex">
                <template v-if="headers.options[colIndex] === 'text[]'">
                  <div class="slds-truncate" :title="headers.names[colIndex]">
                    <IncludedFilter v-model="rowsToShow[index][headers.names[colIndex]]" :ref="`input_${index}__${headers.names[colIndex]}`" />
                  </div>
                </template>
                <template v-else-if="headers.options[colIndex] === 'picklist'">
                  <Picklist
                    v-model="rowsToShow[index][headers.names[colIndex]]"
                    :options="headers.picklistValues[colIndex]"
                    :ref="`input_${index}__${headers.names[colIndex]}`" />
                </template>
                <template v-else>
                  <div class="slds-truncate" :title="headers.names[colIndex]">
                    <Input :type="headers.options[colIndex]" v-model="rowsToShow[index][headers.names[colIndex]]" :ref="`input_${index}__${headers.names[colIndex]}`" />
                  </div>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="showPaginationSection" class="pagination-section slds-m-top--medium">
      <div>
        <button class="slds-button slds-button_neutral" @click="goToFirstPage" :disabled="pageNumber === 0"> &lt;&lt; </button>
        <button class="slds-button slds-button_neutral slds-m-right--small" @click="goToPreviousPage" :disabled="pageNumber === 0"> &lt; </button>
        <span> {{ pageNumber + 1 }} / {{ pageNumbers + 1 }} </span>
        <button class="slds-button slds-button_neutral slds-m-left--small" @click="goToNextPage" :disabled="isNextButtonDisabled"> &gt; </button>
        <button class="slds-button slds-button_neutral" @click="goToLastPage" :disabled="isNextButtonDisabled"> &gt;&gt; </button>
      </div>
    </div>
  </div>
</template>
<script>
import Input from './Input'
import IncludedFilter from '../campaign-manager/filters/IncludedFilter'
import Picklist from './Picklist'

const PAGE_SIZE = 10

export default {
  components: {
    Input,
    IncludedFilter,
    Picklist
  },
  props: {
    columnOptions: Array,
    hasDeleteAction: Boolean,
    headers: Object,
    mode: {
      type: String,
      default: 'view'
    },
    rows: Array
  },
  computed: {
    rowsToShow () {
      if (!this.showPaginationSection) {
        return this.rows
      } else {
        return this.rows.slice(this.startIndex, this.endIndex + 1)
      }
    },
    endIndex () {
      return ((this.pageNumber + 1) * PAGE_SIZE - 1)
    },
    isNextButtonDisabled () {
      return this.rows.length <= (this.pageNumber + 1) * PAGE_SIZE
    },
    pageNumbers () {
      return Math.floor(this.rows.length / PAGE_SIZE)
    },
    showPaginationSection () {
      return this.mode === 'view' && this.rows.length > PAGE_SIZE
    },
    startIndex () {
      return this.pageNumber * PAGE_SIZE
    },
    hasActions () {
      return this.hasDeleteAction
    },
    nbsp () {
      return '\xa0'
    }
  },
  data () {
    return {
      pageNumber: 0
    }
  },
  methods: {
    goToFirstPage () {
      this.pageNumber = 0
    },
    goToLastPage () {
      this.pageNumber = this.pageNumbers
    },
    goToNextPage () {
      this.pageNumber++
    },
    goToPreviousPage () {
      this.pageNumber--
    }
  },
  watch: {
    rows () {
      this.goToFirstPage()
    }
  }
}
</script>
<style lang="scss" scoped>
  .pagination-section {
    bottom: 10px;
    display: flex;
    width: 100%;
    align-items: center;

    & > div {
      margin: auto;
    }
  }

  .wrap {
    width: 5rem;
    word-break: break-word;
    white-space: pre-line;
  }
</style>
